import type { InferType } from 'yup';
import { string } from 'yup';

/**
 * Valid segmentation surface values for **gml-engine**'s Gestalt2 segmentation
 * mask. If **gml-engine**'s output changes at all for these, we'll need to
 * update this schema.
 *
 * @see {@link https://docs.google.com/spreadsheets/d/1chv4bFQrxTDj5T-5jjVyCc6Cgd2uNCbKmVz17w3tk1A/edit?gid=1666152807#gid=1666152807}
 */
export const segmentationSurfaceSchema = string()
  .oneOf([
    'NotAHouse',
    'Door',
    'Wall',
    'Roof',
    'Window',
    'Soffit',
    'Fascia',
    'Basement',
    'Shutter',
    'WindowTrim',
    'NoLabel',
    'GarageDoor',
    'DoorTrim',
    'OtherTrim',
  ])
  .required();

export type SegmentationSurface = InferType<typeof segmentationSurfaceSchema>;
